import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { mergeMap } from "rxjs";
import { ActionService, Outlet, QuestionByTab } from "../../../services/action.service";
import { LoaderService } from "../../../services/loader.service";
import { MyUtils } from "../../../services/my-utils.service";
import { ObjectFrom } from "../../dynamic-form/models/input-form";
import { DynamicFormServices } from "../../dynamic-form/services/dynamic-form.services";

@Component({
  selector: "app-action-plan-dialog",
  templateUrl: "./action-plan-dialog.component.html",
  styleUrls: ["./action-plan-dialog.component.scss"],
})
export class ActionPlanDialogComponent implements OnInit {
  inputForm: ObjectFrom[] = [];

  formGroup: FormGroup = new FormGroup({});

  outlets: Outlet[] = [];
  questions: QuestionByTab[] = [];
  showButton: boolean = false;

  constructor(
    private dynamicFormService: DynamicFormServices,
    public utils: MyUtils,
    private actionService: ActionService,
    private loaderService: LoaderService,
    private dialogRef: MatDialogRef<ActionPlanDialogComponent>
  ) {
    this.loaderService.startLoader();
    this.actionService
      .getDealerOutletList()
      .pipe(
        mergeMap((o) => {
          let markets = this.utils.settingsPayloadValue.payload.network.regions[0].subRegions[0].market;
          this.outlets = o.filter((out) => markets.includes(out.marketId));
          return this.actionService.getQuestionByTab();
        })
      )
      .subscribe((questions) => {
        this.questions = questions;
        this.inputForm = [
          [
            {
              formControlName: "title",
              label: "title",
              placeholder: "title",
              value: undefined,
              validators: {
                required: true,
              },
              template: "input",
              disabled: false,
            },
            {
              formControlName: "description",
              label: "description",
              placeholder: "description",
              value: undefined,
              validators: {
                required: true,
              },
              template: "input",
              disabled: false,
            },
          ],
          [
            {
              formControlName: "outlets",
              label: "outlets",
              placeholder: "outlets",
              value: undefined,
              validators: {
                required: true,
              },
              template: "select",
              objectSelect: this.outlets.map((el) => el.fullName),
              isMultipleSelect: true,
              disabled: false,
            },
          ],
          [
            {
              formControlName: "kpi",
              label: "kpi",
              placeholder: "kpi",
              value: undefined,
              validators: {
                required: true,
              },
              template: "select",
              objectSelect: questions.map((question) => question.questionTranslate),
              disabled: false,
            },
          ],
          [
            {
              formControlName: "kpiGoalValue",
              label: "kpiGoalValue",
              placeholder: "kpiGoalValue",
              value: undefined,
              validators: {
                required: true,
              },
              template: "input",
              disabled: false,
            },
          ],
          [
            {
              formControlName: "dateStart",
              label: "dateStart",
              placeholder: "dateStart",
              value: new Date(),
              validators: {
                required: true,
              },
              template: "dataPicker",
              disabled: false,
              inputType: "number",
            },
            {
              formControlName: "dateEnd",
              label: "dateEnd",
              placeholder: "dateEnd",
              value: new Date(),
              validators: {
                required: true,
              },
              template: "dataPicker",
              disabled: false,
            },
          ],
        ];
        this.formGroup = this.dynamicFormService.generateFormGroup(this.inputForm);
        this.showButton = true;
        this.loaderService.stopLoader();
      });
  }

  ngOnInit(): void { }

  onSave() {
    if (!this.formGroup.valid) return;
    let formValue = this.formGroup.value;
    let stringCode: string = "";
    let findOutlet: any = {}
    let outletList: {}[] = [];
    outletList = formValue.outlets;
    formValue.outlets = [];
    outletList.forEach((el: any) => {
      findOutlet = this.outlets.find((out) => el.includes(out.outletName))
      //console.log(findOutlet)
      stringCode = findOutlet?.outletId+"#"+findOutlet?.dealerId+"#"+findOutlet?.outletName
      formValue.outlets.push(stringCode)
    })

    formValue.kpi = this.questions.find((q) => q.questionTranslate === formValue.kpi)?.questionCode;
    this.dialogRef.close(formValue);
  }
}
